import * as Sailcloth from "./vendor/sailcloth/sailcloth";
import { XY } from "./vendor/sailcloth/sailcloth";
import { BoardDataSource } from "./board-data-source";
import Transition from "./transition";
const DEFAULT_ZOOM = 56;
export class Board extends Sailcloth.Renderable {
    constructor(options = {}) {
        super();
        this.options = options || {};
        this.squareSize = DEFAULT_ZOOM;
        this._app = this.options.app || null;
        this.letterStyleOverrides = {};
        this.shouldUseFastRendering = false;
        this.dataSource =
            this.options.dataSource || new BoardDataSource({ tileBlockSize: 5 });
        this.lang = this.options.lang || "en";
    }
    setSelectedLetter(bx, by) {
        this.selectedLetter = { bx: bx, by: by };
        if (this.viewport) {
            this.viewport.refresh();
        }
    }
    clearSelectedLetter() {
        this.selectedLetter = null;
        if (this.viewport) {
            this.viewport.refresh();
        }
    }
    fadeInLetters(keys) {
        const from = "#44ddff";
        const to = "#ffdd44";
        for (const k of keys) {
            this.letterStyleOverrides[k] = from;
        }
        Transition.color({ from: from, to: to, duration: 300 }, color => {
            for (const k of keys) {
                this.letterStyleOverrides[k] = color;
            }
            this.viewport.refresh();
            if (color == to) {
                for (const k of keys) {
                    delete this.letterStyleOverrides[k];
                }
            }
        });
    }
    toggleZoom() {
        this.setZoom(this.squareSize == DEFAULT_ZOOM ? "wide" : "normal");
    }
    setZoom(level) {
        if (level == "normal") {
            this.squareSize = DEFAULT_ZOOM;
        }
        else if (level == "wide") {
            this.squareSize = 12;
        }
        else {
            throw `invalid zoom level '${level}'`;
        }
    }
    render(viewport, sinceLastFrame) {
        this.renderLetters(viewport);
        if (this.squareSize > 16) {
            this.renderGrid(viewport);
        }
        else {
            // in zoomed out mode we want to render a box over the center of the page
            // so its possible to see where to zoom back into
            const w = 100;
            const h = 66;
            viewport.context.strokeStyle = "red";
            viewport.context.lineWidth = 1.0;
            viewport.context.strokeRect(viewport.center.x - w / 2, viewport.center.y - h / 2, w, h);
        }
    }
    renderLetters(viewport) {
        const bounds = this.viewportBoxBounds(viewport);
        for (let bx = bounds.left; bx <= bounds.right; bx++) {
            for (let by = bounds.top; by <= bounds.bottom; by++) {
                const letter = this.dataSource.get(bx, by);
                const bonus = this.dataSource.bonusTiles[`${bx}:${by}`];
                if (letter) {
                    this.renderLetter(viewport, bx, by, letter);
                }
                else if (bonus) {
                    this.renderBonus(viewport, bx, by, bonus);
                }
            }
        }
    }
    renderBonus(viewport, bx, by, bonus) {
        const rect = this.rectForBox(bx, by);
        const text = bonus == "x2" ? "×2" : "×3";
        viewport.context.fillStyle = bonus == "x2" ? "#98DEFF" : "#FF98AB";
        viewport.context.fillRect(rect.origin.x, rect.origin.y, this.squareSize, this.squareSize);
        if (this.squareSize > 32) {
            viewport.context.fillStyle = "#fff";
            viewport.context.textBaseline = "middle";
            viewport.context.textAlign = "center";
            viewport.context.font = "28pt Arial";
            viewport.context.fillText(text, rect.center.x - 2, rect.center.y);
        }
    }
    renderGrid(viewport) {
        const b = viewport.rect.bounds;
        viewport.context.strokeStyle = "#ddd";
        viewport.context.lineWidth = 1.0;
        b.top -= (b.top % this.squareSize) + this.squareSize;
        b.left -= (b.left % this.squareSize) + this.squareSize;
        for (let x = b.left; x < b.right; x += this.squareSize) {
            viewport.context.beginPath();
            viewport.context.setLineDash([4, 4]);
            viewport.context.moveTo(x + 0.5, b.top + 2);
            viewport.context.lineTo(x + 0.5, b.bottom);
            viewport.context.stroke();
        }
        for (let y = b.top; y < b.bottom; y += this.squareSize) {
            viewport.context.beginPath();
            viewport.context.moveTo(b.left + 2, y + 0.5);
            viewport.context.lineTo(b.right, y + 0.5);
            viewport.context.stroke();
        }
        if (this.hoverBox) {
            const rect = this.rectForBox(this.hoverBox.bx, this.hoverBox.by);
            viewport.context.setLineDash([8, 4]);
            viewport.context.strokeStyle = "red";
            viewport.context.lineWidth = 3.0;
            viewport.context.strokeRect(rect.origin.x, rect.origin.y, this.squareSize, this.squareSize);
            /*
                  let text = `${this.hoverBox.bx}, ${this.hoverBox.by}`
                  viewport.context.strokeStyle = "#ddd";
                  viewport.context.font = "8pt Arial";
                  viewport.context.textBaseline = "top";
                  viewport.context.textAlign = "left";
                  viewport.context.fillText(text, rect.origin.x + 6, rect.origin.y + 4);
                  */
        }
        // if this letter is selected, then render a box around it
        if (this.selectedLetter) {
            const rect = this.rectForBox(this.selectedLetter.bx, this.selectedLetter.by);
            viewport.context.setLineDash([8, 4]);
            viewport.context.strokeStyle = "red";
            viewport.context.lineWidth = 3.0;
            viewport.context.strokeRect(rect.origin.x, rect.origin.y, this.squareSize, this.squareSize);
        }
        viewport.context.setLineDash([]);
    }
    // normally this sort of thing would be in its own class, but we could be rendering
    // lots of these so it will be faster to just do it inside the grid object
    renderLetter(viewport, bx, by, c) {
        if (!c)
            return;
        const fontFace = this.lang == "en" ? "Zerofour" : "Arial";
        const ctx = viewport.context;
        const rect = this.rectForBox(bx, by);
        // render the square
        if (this.letterStyleOverrides[this.dataSource.key(bx, by)]) {
            ctx.fillStyle = this.letterStyleOverrides[this.dataSource.key(bx, by)];
        }
        else if (this.dataSource.isPending(bx, by)) {
            ctx.fillStyle = "#4df";
        }
        else {
            ctx.fillStyle = "#fd4";
        }
        ctx.fillRect(rect.origin.x, rect.origin.y, this.squareSize, this.squareSize);
        if (!this.shouldUseFastRendering) {
            // now render the main letter
            ctx.fillStyle = "#222";
            ctx.textBaseline = "middle";
            ctx.textAlign = "center";
            if (this.squareSize < 16) {
                ctx.font = `${this.squareSize}px ${fontFace}`;
                ctx.fillText(c.toUpperCase(), rect.center.x + 1, rect.center.y + 1);
            }
            else {
                ctx.font = `40px ${fontFace}`;
                ctx.fillText(c.toUpperCase(), rect.center.x + 2, rect.center.y);
            }
            // now the letter value in the bottom left
            const v = this.dataSource.letterValue(c);
            if (v && this.squareSize > 32) {
                ctx.fillStyle = "#888";
                ctx.font = "11pt Arial";
                ctx.textBaseline = "bottom";
                ctx.textAlign = "left";
                ctx.fillText(v.toString(), rect.bounds.left + 3, rect.bounds.bottom - 1);
            }
        }
    }
    rectForBox(bx, by) {
        return new XY.Rect(bx * this.squareSize, by * this.squareSize, this.squareSize, this.squareSize);
    }
    boxAt(x, y) {
        return {
            bx: Math.floor(x / this.squareSize),
            by: Math.floor(y / this.squareSize),
        };
    }
    // returns the bounds in terms of boxes for the viewport
    viewportBoxBounds(viewport) {
        if (viewport instanceof Sailcloth.WorldViewport) {
            const bounds = viewport.rect.bounds;
            const topLeft = this.boxAt(bounds.left, bounds.top);
            const bottomRight = this.boxAt(bounds.right, bounds.bottom);
            return {
                top: topLeft.by,
                left: topLeft.bx,
                bottom: bottomRight.by,
                right: bottomRight.bx,
                height: bottomRight.by - topLeft.by,
                width: bottomRight.bx - topLeft.bx,
            };
        }
        else {
            throw "WorldViewport required";
        }
    }
}
